function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 508.96 508.96",
  style: {
    "enableBackground": "new 0 0 508.96 508.96"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 378.001,
  y: 92.921,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 582.4434 534.8898)",
  style: {
    "fill": "#636464"
  },
  width: 48,
  height: 107.791
}), /*#__PURE__*/React.createElement("rect", {
  x: 53.078,
  y: 122.866,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 78.7652 326.358)",
  style: {
    "fill": "#636464"
  },
  width: 107.791,
  height: 48
}), /*#__PURE__*/React.createElement("rect", {
  x: 230.48,
  y: 24.016,
  style: {
    "fill": "#636464"
  },
  width: 48,
  height: 107.776
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#787878"
  },
  d: "M325.504,48H183.44c-13.264,0-24-10.752-24-24s10.736-24,24-24h142.064c13.264,0,24,10.752,24,24 S338.768,48,325.504,48z"
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#787878"
  },
  cx: 254.48,
  cy: 297.744,
  r: 211.216
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.15
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M254.48,494.224C146.144,494.224,58,406.08,58,297.744c0-108.32,88.144-196.464,196.48-196.464 s196.48,88.144,196.48,196.464C450.96,406.08,362.816,494.224,254.48,494.224z M254.48,133.28 C163.792,133.28,90,207.056,90,297.744c0,90.704,73.776,164.48,164.48,164.48s164.48-73.776,164.48-164.48 C418.96,207.056,345.168,133.28,254.48,133.28z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#DAEFF6"
  },
  d: "M254.48,146.864c-83.328,0-150.88,67.552-150.88,150.88s67.552,150.88,150.88,150.88 s150.88-67.552,150.88-150.88H254.48V146.864z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E95454"
  },
  d: "M254.48,146.864v150.88h150.88C405.36,214.416,337.808,146.864,254.48,146.864z"
}), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.07
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#010101"
  },
  d: "M254.48,169.824c79.472,0,144.4,61.552,150.304,139.376c0.288-3.808,0.576-7.632,0.576-11.52 c0-83.2-67.52-150.88-150.88-150.88S103.6,214.48,103.6,297.68c0,3.888,0.288,7.712,0.576,11.52 C110.08,231.376,175.008,169.824,254.48,169.824z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FDBC4B"
  },
  d: "M256.832,294.96c-3.12-3.12-3.12-8.192,0-11.312l74.896-74.896c3.12-3.12,8.192-3.12,11.312,0 c3.12,3.12,3.12,8.192,0,11.312l-74.896,74.896C265.008,298.096,259.952,298.096,256.832,294.96z"
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#FFCC5B"
  },
  cx: 254.48,
  cy: 297.744,
  r: 25.104
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M254.48,168.352c-4.416,0-8,3.584-8,8v23.456c0,4.416,3.584,8,8,8c4.416,0,8-3.584,8-8v-23.456 C262.48,171.936,258.896,168.352,254.48,168.352z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M254.48,387.68c-4.416,0-8,3.584-8,8v23.456c0,4.416,3.584,8,8,8c4.416,0,8-3.584,8-8V395.68 C262.48,391.264,258.896,387.68,254.48,387.68z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M375.872,289.744h-23.456c-4.416,0-8,3.584-8,8s3.584,8,8,8h23.456c4.416,0,8-3.584,8-8 S380.288,289.744,375.872,289.744z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFFFFF"
  },
  d: "M156.544,289.744h-23.456c-4.416,0-8,3.584-8,8s3.584,8,8,8h23.456c4.416,0,8-3.584,8-8 S160.96,289.744,156.544,289.744z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/chrono.ee2f4f89.svg";
export { SvgComponent as ReactComponent };